module.exports = __webpack_public_path__ + "img/phase2-2015-02-03.8b9f3ed7.jpg";